import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { createOutcome } from "./api";
import { invalidateAllQueries } from "utils/utils";

export function useCreateOutcome({ ...options } = {}) {
    return useMutation({
        mutationFn: ({ item }) => createOutcome({ item }),
        onSuccess: (data) => {
            invalidateAllQueries();
            toast.success("Outcome created");
            options.onSuccess?.(data);
        },
        onError: (err) => {
            toast.error("Error creating outcome");
            options.onError?.(err);
        },
    });
}